import { User, GenerateUndefinedUser } from "../auth/types";
import {
  Environment,
  GenerateUndefinedEnvironment,
  GenerateUndefinedJob,
  GenerateUndefinedAnswerList
} from "../common/types";
import { Job, JobDetail, Answer } from "../common/interfaces";

export default class State {
  public User: User;
  public Environment: Environment;
  public Job: Job;
  public Answers: Answer[];
  public EMPTY_STRING: string;
  constructor() {
    this.User = GenerateUndefinedUser();
    this.Environment = GenerateUndefinedEnvironment();
    this.Job = GenerateUndefinedJob();
    this.Answers = GenerateUndefinedAnswerList();
    this.EMPTY_STRING = "[None]";
  }
}
